import { render, staticRenderFns } from "./NewTestPage.vue?vue&type=template&id=31145b75&scoped=true"
import script from "./NewTestPage.vue?vue&type=script&lang=js"
export * from "./NewTestPage.vue?vue&type=script&lang=js"
import style0 from "./NewTestPage.vue?vue&type=style&index=0&id=31145b75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31145b75",
  null
  
)

export default component.exports